import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'app-mrejesho-search-tgsd',
  templateUrl: './mrejesho-search-tgsd.component.html',
  styleUrl: './mrejesho-search-tgsd.component.scss'
})
export class MrejeshoSearchTgsdComponent {
  searchedKeyword:any;

  onSearchChange(value){
    console.log(value)
    this.searchedKeyword =value;
  }

  @Output() exitHover = new EventEmitter();
}
